import { connect } from 'react-redux';
import SharePage from '../../components/SharePage';

export default connect()(SharePage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SharePage/index.ts